import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, RegularShape, Icon } from 'ol/style.js';
import GeoJSON from "ol/format/GeoJSON";
import { Circle as CircleStyle, Text } from 'ol/style';
import { easeOut } from 'ol/easing.js';
import { fromLonLat, toLonLat } from 'ol/proj.js';
import { getVectorContext } from 'ol/render.js';
import { getDistance } from 'ol/sphere';
import { unByKey } from 'ol/Observable.js';
import { hexToRgba, settingsConfig } from 'utils/commonFunc';
import { runAnimationFeature, setMapSingleEventHandler } from 'map/OlExtension'
import { Feature } from 'ol';
import { LineString, Point } from 'ol/geom';

export default class BoundaryVmsLayer extends VectorLayer {
    styleGray = new Style({
        radius: 10,
        stroke: new Stroke({
            color: 'rgba( 255, 0, 0, 0.9)',
            width: 4
        }),
        fill: new Fill({
            color: 'rgba( 255, 0, 0, 0.7)'
        })
    });

    constructor(map) {
        super({
            name: 'boundaryVmsLayer',
            source: new VectorSource(),
            //style: (feature) => this.styleFunction(feature),
        });
        this.map = map;
        this.map?.addLayer(this);
    }

    createLinkPosition = (items, wm = 0, hm = 0) => {
        const useWidth = this.map.getSize()[0] / 3
        const fullHeight = this.map.getSize()[1]
        const brokenWidth = useWidth + useWidth / 20
        const topMargin = (fullHeight / 22) + hm
        const bottomMargin = (fullHeight / 22) + hm
        const intersectionGap = useWidth / 1.9
        const leftCount = items.length / 2 >> 0
        const rightCount = leftCount + items.length % 2

        const size = this.map.getSize()
        const width = size[0]
        const height = (size[1] - topMargin - bottomMargin)

        const leftTick = height / leftCount
        const rightTick = height / rightCount

        const leftPixels = []
        let gapCount = 0
        for (var i = leftTick / 2; i < height; i += leftTick) {
            const widthGap = (gapCount++ % 2 ? intersectionGap : 0) + wm;
            leftPixels.push({
                positioning: 'center-left',
                target: toLonLat(this.map.getCoordinateFromPixel([widthGap + 0, topMargin + i >> 0])),
                broken: toLonLat(this.map.getCoordinateFromPixel([widthGap + 0 + (brokenWidth - widthGap), topMargin + i >> 0]))
            })
        }
        const rightPixels = []
        gapCount = 0
        for (i = rightTick / 2; i < height; i += rightTick) {
            const widthGap = (gapCount++ % 2 ? intersectionGap : 0) + wm;
            rightPixels.push({
                positioning: 'center-right',
                target: toLonLat(this.map.getCoordinateFromPixel([width - widthGap, topMargin + i >> 0])),
                broken: toLonLat(this.map.getCoordinateFromPixel([width - widthGap - (brokenWidth - widthGap), topMargin + i >> 0]))
            })
        }

        let dummy = [...items]
        let dummyPixels = [...leftPixels, ...rightPixels]
        let matchingItems = []

        while (dummy.length > 0) {

            const itemsWithDistance = (function (dummy, dummyPixels) {
                return dummy.map((item) => {
                    const coordinate = [item.x, item.y]

                    var minPixel = dummyPixels.reduce(function (prev, current) {
                        const distancePrev = getDistance(coordinate, prev.target);
                        const distanceCurrent = getDistance(coordinate, current.target);
                        return (distancePrev < distanceCurrent) ? prev : current;
                    })

                    const minPixeldistance = getDistance(coordinate, minPixel.target);
                    return { ...item, minPixel, minPixeldistance }
                })
            })(dummy, dummyPixels)

            const minDistanceItem = itemsWithDistance.reduce(function (prev, current) {
                return (prev.minPixeldistance < current.minPixeldistance) ? prev : current;
            })

            dummy = dummy.filter(p => p.id !== minDistanceItem.id)
            dummyPixels = dummyPixels.filter(p => p !== minDistanceItem.minPixel)
            matchingItems.push(minDistanceItem)
        }

        // const getVerticalSortMapping = (items, pixels) => {
        //     const positioning = pixels[0].positioning
        //     const sortdItems = items.filter(p => p.minPixel.positioning === positioning).sort((a, b) => {
        //         const coordinateA = fromLonLat([a.x, a.y])
        //         const coordinateB = fromLonLat([b.x, b.y])
        //         return coordinateB[1] - coordinateA[1]
        //     })
        //     return sortdItems.map((item, idx) => {
        //         const pixel = pixels[idx]
        //         return { ...item, coordinatePixels: [pixel.target, pixel.broken], positioning: pixel.positioning }            
        //     });
        // }

        // const getVerticalSortMapping = (items, pixels) => {
        //     const positioning = pixels[0].positioning
        //     const sortedItems = items
        //         .filter(p => p.minPixel.positioning === positioning)
        //         .sort((a, b) => {
        //             const coordinateA = fromLonLat([a.x, a.y])
        //             const coordinateB = fromLonLat([b.x, b.y])
        //             return coordinateB[1] - coordinateA[1]
        //         })

        //     const distanceThreshold = 3000; // 이 값은 원하는 거리 기준(px 거리)에 따라 조정하세요.

        //     return sortedItems.map((item, idx) => {
        //         const pixel = pixels[idx]
        //         const distance = getDistance([item.x, item.y], pixel.target)

        //         const coordinatePixels = (distance < distanceThreshold)
        //             ? [pixel.target] 
        //             : [pixel.target, pixel.broken] 

        //         return {
        //             ...item,
        //             coordinatePixels,
        //             positioning: pixel.positioning
        //         }
        //     });
        // }
        const getVerticalSortMapping = (items, pixels) => {
            const positioning = pixels[0].positioning;
            const sortedItems = items
                .filter(p => p.minPixel.positioning === positioning)
                .sort((a, b) => {
                    const coordinateA = fromLonLat([a.x, a.y]);
                    const coordinateB = fromLonLat([b.x, b.y]);
                    return coordinateB[1] - coordinateA[1];
                });


            const distanceThreshold = 100; // 원하는 거리 기준(px 거리)

            return sortedItems.map((item, idx) => {
                const pixel = pixels[idx];
                const distance = getDistance([item.x, item.y], pixel.target);

                const straightNames = ['서수원체육공원앞', '신대저수지연화장입구', '삼성교사거리앞', '삼성삼거리', '청명역(영통휴먼시아맞은편)', '인계동삼성아파트앞', '동수원병원전'
                    , '도이치오토월드', '중부소방서맞은편','광교마을40단지' ,'광교도서관앞' , '합동신학대학교앞' , '호매실지하차도(IC방향)', '호매실지하차도(수원역방향)' ,'숙지중맞은편' ,'금곡로사거리앞','금곡칠보마을입구' 
                    , '선일초교앞' ,'망포역사거리' , '율전중삼거리' ,'고색파출소' ,'지지대쉼터앞' ,'당수IC', '수원시청' ,'인계사거리' , '광교상현IC출구' , '권선지하차도남단' ,'비상활주로'
                ];
                const isStraightLineName = straightNames.includes(item.name);

                const coordinatePixels = (isStraightLineName || distance < distanceThreshold)
                    ? [pixel.target] // 직선
                    : [pixel.target, pixel.broken]; // 꺾인 선

                return {
                    ...item,
                    coordinatePixels,
                    positioning: pixel.positioning
                };
            });
        }
        return [...getVerticalSortMapping(matchingItems, leftPixels), ...getVerticalSortMapping(matchingItems, rightPixels)]

        // const result = matchingItems.map(item => {
        //     return { ...item, coordinatePixels: [item.minPixel.target, item.minPixel.broken], positioning: item.minPixel.positioning }
        // })
        // return result
    }

    // setFeatures = (items) => {
    //     const vectorSource = this.getSource();
    //     vectorSource.clear()
    //     items.forEach(item => {
    //         const coordinate = fromLonLat([item.x, item.y]);
    //         const feature = new Feature({
    //             id: item.id,
    //             geometry: new Point(coordinate),
    //             properties: item,
    //         });

    //         const defaultStyle = new Style({
    //             image: new RegularShape({
    //                 radius: 20,
    //                 points: 3,
    //                 angle: Math.PI,
    //                 displacement: [2, 5],
    //                 fill: new Fill({
    //                     color: "rgba(25, 255, 25, 0.5)"
    //                 }),
    //                 stroke: new Stroke({
    //                     color: "rgba(25, 255, 25, 1)",
    //                     width: 3
    //                 })
    //             }),
    //             geometry: feature.getGeometry(),
    //             zIndex: 0
    //         })
    //         const lineStyle = new Style({
    //             stroke: new Stroke({
    //                 color: 'rgba(255, 255, 255, 0.5)',
    //                 width: 4,
    //             }),
    //             geometry: new LineString([
    //                 ...item.coordinatePixels.map(p => fromLonLat(p)),
    //                 feature.getGeometry().getCoordinates()].reverse())
    //         });

    //         const lineStyleCoordinates = lineStyle.getGeometry().getCoordinates()
    //         feature.set('animationLineString', [new LineString([
    //             lineStyleCoordinates[0],
    //             lineStyleCoordinates[1]
    //         ]),
    //         new LineString([
    //             lineStyleCoordinates[1],
    //             lineStyleCoordinates[2]
    //         ])])
    //         feature.setStyle([defaultStyle, lineStyle])

    //         vectorSource.addFeature(feature);
    //     });
    //     this.startAnimationFeature()
    // }

    setFeatures = (items) => {
        const vectorSource = this.getSource();
        vectorSource.clear();

        items.forEach(item => {
            const coordinate = fromLonLat([item.x, item.y]);
            const feature = new Feature({
                id: item.id,
                geometry: new Point(coordinate),
                properties: item,
            });

            // 기본 마커 스타일
            const defaultStyle = new Style({
                image: new RegularShape({
                    radius: 20,
                    points: 3,
                    angle: Math.PI,
                    displacement: [2, 5],
                    fill: new Fill({
                        color: "rgba(25, 255, 25, 0.5)"
                    }),
                    stroke: new Stroke({
                        color: "rgba(25, 255, 25, 1)",
                        width: 3
                    })
                }),
                geometry: feature.getGeometry(),
                zIndex: 0
            });

            // 선 좌표 설정 (coordinatePixels + 본래 좌표)
            // const lineCoords = [
            //     ...item.coordinatePixels.map(p => fromLonLat(p)),
            //     feature.getGeometry().getCoordinates()
            // ].reverse();
            const lineCoords = [
                ...item.coordinatePixels.map(p => fromLonLat(p)), // 이미 offset이 적용된 좌표
                fromLonLat([item.x, item.y]) // 원본 목적지 좌표
            ].reverse();

            const lineStyle = new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 0.3)',
                    width: 1.8,
                }),
                geometry: new LineString(lineCoords)
            });

            let animationLineStrings = [];
            if (item.coordinatePixels.length === 2) {
                animationLineStrings = [
                    new LineString([fromLonLat(item.coordinatePixels[0]), fromLonLat(item.coordinatePixels[1])]),
                    new LineString([fromLonLat(item.coordinatePixels[1]), feature.getGeometry().getCoordinates()])
                ];
                } else if (item.coordinatePixels.length === 1) {
                    animationLineStrings = [
                        new LineString([
                            fromLonLat(item.coordinatePixels[0]),
                            feature.getGeometry().getCoordinates()
                        ])
                    ];
                }
            
            feature.set('animationLineString', animationLineStrings);
            feature.setStyle([defaultStyle, lineStyle]);

            vectorSource.addFeature(feature);
        });

        this.startAnimationFeature();
    }

    // startAnimationFeature = () => {
    //     runAnimationFeature(this, 'animationKey', 600, (feature, hashTable, progress) => {
    //         const currentRadius = hashTable.currentRadius
    //         const animationLineString = feature.get('animationLineString')
    //         const styles = feature.getStyle();
    //         const line = styles[1].getGeometry()
    //         if (progress <= 0.5) {
    //             const subLine = animationLineString[0].getCoordinateAt(progress / 0.5);
    //             line.setCoordinates([animationLineString[0].getCoordinates()[0], subLine]);
    //         } else {
    //             const subLine = animationLineString[1].getCoordinateAt((progress - 0.5) / 0.5);
    //             line.setCoordinates([...animationLineString[0].getCoordinates(), subLine]);
    //         }

    //         const markerStyle = styles[0];
    //         const fill = markerStyle.getImage().getFill();
    //         const stroke = markerStyle.getImage().getStroke();
    //         markerStyle.setImage(new RegularShape({
    //             radius: currentRadius,
    //             points: 3,
    //             angle: Math.PI,
    //             displacement: [0, currentRadius / 2],
    //             fill: fill,
    //             stroke: stroke
    //         }))

    //         feature.setStyle(styles);
    //     }, {
    //         progressCallBack: (progress, hashTable) => {
    //             hashTable.currentRadius = 10 * progress
    //         }
    //     });
    // }
    startAnimationFeature = () => {
        runAnimationFeature(this, 'animationKey', 600, (feature, hashTable, progress) => {
            const currentRadius = hashTable.currentRadius;
            const animationLineString = feature.get('animationLineString');
            const styles = feature.getStyle();
            const line = styles[1].getGeometry();

            if (animationLineString.length === 2) {
                if (progress <= 0.5) {
                    const subLine = animationLineString[0].getCoordinateAt(progress / 0.5);
                    line.setCoordinates([animationLineString[0].getCoordinates()[0], subLine]);
                } else {
                    const subLine = animationLineString[1].getCoordinateAt((progress - 0.5) / 0.5);
                    line.setCoordinates([
                        ...animationLineString[0].getCoordinates(),
                        subLine
                    ]);
                }
            } else if (animationLineString.length === 1) {
                const subLine = animationLineString[0].getCoordinateAt(progress);
                line.setCoordinates([
                    animationLineString[0].getCoordinates()[0],
                    subLine
                ]);
            }

            // 마커 애니메이션
            const markerStyle = styles[0];
            const fill = markerStyle.getImage().getFill();
            const stroke = markerStyle.getImage().getStroke();
            markerStyle.setImage(new RegularShape({
                radius: currentRadius,
                points: 3,
                angle: Math.PI,
                displacement: [0, currentRadius / 2],
                fill: fill,
                stroke: stroke
            }));

            feature.setStyle(styles);
        }, {
            progressCallBack: (progress, hashTable) => {
                hashTable.currentRadius = 10 * progress;
            }
        });
    }
}